import React from 'react'
import { Button, Icon } from '@material-ui/core';
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Usuario from './Usuario';

export default class Usuarios extends TableComponent {

  componentDidMount() {
    this.setState({ addUser: false });
    this.tableConfig(
      { dataUrl: 'usuario/filter', deleteUrl: 'usuario/delete', deleteField: 'usuario_nombre', modUrl: '/ConfiguracionSistema/usuario' },
      TableOp.Table('', [
        { label: 'Correo', id: 'email' },
        { label: 'Nombre', id: 'nombre' },
        { label: 'Apellido Paterno', id: 'apellido_paterno' },
        { label: 'Apellido Materno', id: 'apellido_materno' },
        { label: 'Sucursal', id: 'sucursal_nombre' },
        { label: 'Rol', id: 'rol_nombre' },
        { label: 'Estado', id: 'estado_situacion' },
      ], [
        { id: 'edit', icon: 'edit', access: [] },
        // { id: 'delete', icon: 'delete' }, No se deben eliminar usuarios
      ]))
    this.table();
  }

  action = (id, row) => {
		if (id === 'edit') {
      this.setState({ addUser: true, id_user: row.id })
			// this.props.history.push(`${this.config.modUrl}/${row.id}`)
		}
	}

  render() {

    return (
      <div style={{ width: 'calc(100% - 30px)', margin: '15px' }} >
        {
          this.state.addUser
            ? (<Usuario 
                  {...this.props}
                  id_user={this.state.id_user}
                  onSave={() => { this.setState({ addUser: false, id_user: false }); this.table(); }}>
                </Usuario>)
            : (
              <div style={{ margin: "10px 10px" }} >
                <Button
                  onClick={() => { this.setState({ addUser: true }) }}
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<Icon>add</Icon>}
                >
                  Agregar Usuario
                </Button>
              </div>
            )
        }

        <this.TableRender {...this.props} />
      </div>
    )
  }
}
